
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/avatar",
      function () {
        return require("private-next-pages/joy-ui/api/avatar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/avatar"])
      });
    }
  